export const GET_CUSTOMERS = 'roasters/GET_CUSTOMERS';
export const GET_CUSTOMERS_SUCCESS = 'roasters/GET_CUSTOMERS_SUCCESS';
export const GET_CUSTOMERS_FAILED = 'roasters/GET_CUSTOMERS_FAILED';

export const GET_CUSTOMER_SATISFACTION = 'roasters/GET_CUSTOMER_SATISFACTION';
export const GET_CUSTOMER_SATISFACTION_SUCCESS = 'roasters/GET_CUSTOMER_SATISFACTION_SUCCESS';
export const GET_CUSTOMER_SATISFACTION_FAILED = 'roasters/GET_CUSTOMER_SATISFACTION_FAILED';
